export enum Pages {
  Chat = '/',
  PDFViewer = '/pdf-viewer',
  NotFound = '*',
}
